import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'public/positionshare/';

class PositionShareService {

    getPublicPosition(token) {
        return axios.get(
            API_URL + encodeURIComponent(token),
            {
                withCredentials: false
            }
        );
    }
}

export default new PositionShareService();